export default __webpack_public_path__ + "static/media/GothaBolIta.355ead40.otf";